// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ShoppingBasketIconSignature {
  Element: SVGSVGElement;
}

export const ShoppingBasketIcon: TOC<ShoppingBasketIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.58 9.99999H22V12H20.802L18.977 20.217C18.875 20.675 18.469 21 18 21H6C5.531 21 5.125 20.675 5.023 20.217L3.198 12H2V9.99999H5.42L9.132 3.50299L10.869 4.49599L7.723 9.99999H16.277L13.132 4.49499L14.868 3.50299L18.58 9.99999ZM6.803 19H17.197L18.754 12H5.246L6.803 19Z"/>
</svg>
</template>;